import { pair } from "./pairs";
export default function (a, b, f) {
  var na = a.length,
      nb = b.length,
      c = new Array(na * nb),
      ia,
      ib,
      ic,
      va;
  if (f == null) f = pair;

  for (ia = ic = 0; ia < na; ++ia) {
    for (va = a[ia], ib = 0; ib < nb; ++ib, ++ic) {
      c[ic] = f(va, b[ib]);
    }
  }

  return c;
}